module.exports = __webpack_public_path__ + "media/img/home/directions/mobile/direction1-7f49ac010495f9f8c61295117d9fcd08.svg";